import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface PageMeta {
  subtitle?: string;
}

interface PageMetaContextType {
  meta: PageMeta;
  setMeta: (meta: PageMeta) => void;
}

const PageMetaContext = createContext<PageMetaContextType | undefined>(undefined);

export function PageMetaProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<PageMeta>({});
  return (
    <PageMetaContext.Provider value={{ meta, setMeta }}>
      {children}
    </PageMetaContext.Provider>
  );
}

export function usePageMetaContext() {
  const ctx = useContext(PageMetaContext);
  if (!ctx) throw new Error('usePageMetaContext must be used within PageMetaProvider');
  return ctx;
}

/** Call from a page component to set the header subtitle for the current route. */
export function usePageMeta(meta: PageMeta) {
  const { setMeta } = usePageMetaContext();
  useEffect(() => {
    setMeta(meta);
    return () => setMeta({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta.subtitle]);
}
